<template>
  <div>
    <ts-dialog title="Edit final asset" :visible.sync="visible" width="850px" center :show-close="false">
      <div class="form-row">
        <ts-form-item label="File name" :validation="$v.form.name" class="form-item">
          <ts-input v-model.lazy="$v.form.name.$model"></ts-input>
        </ts-form-item>
        <ts-form-item label="Platform(s)" :validation="$v.form.platforms" class="form-item">
          <MultiSelectionDropdown
            placeholder="Select platform(s)"
            size="large"
            :width="320"
            :options="platforms"
            v-model.lazy="$v.form.platforms.$model"
          ></MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <span slot="footer">
        <ts-button @click="handleSaveClick">Save</ts-button>
      </span>
    </ts-dialog>
    <ts-button size="small" circle @click="handleEditClick">
      <ts-icon icon="pen" size="x-small" color="#6d7587" title="Edit" />
    </ts-button>
  </div>
</template>

<style lang="scss" scoped>
.form-row {
  display: flex;
  padding: 12px 18px;
  align-items: flex-end;

  .checkbox {
    margin-bottom: 30px;
  }

  .actions {
    margin-bottom: 14px;
  }

  .form-item {
    margin: 0 10px;
  }
}
</style>

<script>
import { cloneDeep } from 'lodash';
import { required } from 'vuelidate/lib/validators';

import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';

export default {
  components: {
    MultiSelectionDropdown
  },
  props: {
    platforms: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      form: cloneDeep(this.value)
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      platforms: {
        required
      }
    }
  },
  methods: {
    handleEditClick() {
      this.form = cloneDeep(this.value);
      this.$v.$reset();
      this.visible = true;
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
        this.visible = false;
      }
    }
  }
};
</script>
